var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.siteKey,"data-theme":"light","data-callback":"verifyMethod","data-expired-callback":"expiredMethod","data-error-callback":"errordMethod"}})
}
var staticRenderFns = []

export { render, staticRenderFns }